export const route = {
    patterns: { search: '/search' },
    searchParams: {
        searchTermParam: 'searchTerm',
        skillIdsParam: 'skillIdsParam',
        tabParam: 'tab',
    },
} as const;
